import { Component } from '@angular/core';

@Component({
    selector: 'gl-tickets-parent-page',
    templateUrl: './tickets-parent-page.component.html',
    styleUrls: ['./tickets-parent-page.component.css']
})
export class TicketsParentPageComponent {}
